import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock, X } from 'lucide-react';
import { SpecialDate } from '../types';

interface SpecialDateCardProps {
  date: SpecialDate;
  onDelete: (id: string) => void;
}

export function SpecialDateCard({ date, onDelete }: SpecialDateCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-50 rounded-lg p-4 relative group"
    >
      <button
        onClick={() => onDelete(date.id)}
        className="absolute top-3 left-3 opacity-0 group-hover:opacity-100 transition-opacity text-gray-400 active:text-red-600"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        {date.is_closed ? (
          <div className="p-2 bg-red-100 rounded-lg">
            <AlertTriangle className="h-5 w-5 text-red-600" />
          </div>
        ) : (
          <div className="p-2 bg-blue-100 rounded-lg">
            <Clock className="h-5 w-5 text-blue-600" />
          </div>
        )}
        <div className="flex-1">
          <h3 className="text-sm font-medium text-gray-900">
            {new Date(date.date).toLocaleDateString('he-IL', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </h3>
          {date.is_closed ? (
            <p className="text-xs text-red-600 mt-1">סגור</p>
          ) : (
            <p className="text-xs text-gray-600 mt-1">
              {date.start_time} - {date.end_time}
            </p>
          )}
          {date.note && (
            <p className="text-xs text-gray-500 mt-2">{date.note}</p>
          )}
        </div>
      </div>
    </motion.div>
  );
}